export enum AuthTypes {
  AUTH_REQUEST = 'auth_request',
  AUTH_ERROR = 'auth_error',
  AUTH_SUCCESS = 'auth_success',
  AUTH_LOGOUT = 'auth_logout',
}

export interface IAuthState {
  authInit: boolean
  authRequest: boolean
  authError: string
  authToken: string
}

interface IAuthLogoutAction {
  type: typeof AuthTypes.AUTH_LOGOUT
}

interface IAuthSuccessAction {
  type: typeof AuthTypes.AUTH_SUCCESS
  authToken: string
}

interface IAuthErrorAction {
  type: typeof AuthTypes.AUTH_ERROR
  authError: string
}

interface IAuthRequestAction {
  type: typeof AuthTypes.AUTH_REQUEST
}

export type AuthActionTypes = IAuthLogoutAction | IAuthSuccessAction | IAuthErrorAction | IAuthRequestAction
export type AuthState = IAuthState

export const initialState: AuthState = {
  authInit: false,
  authRequest: false,
  authError: null,
  authToken: null
}

export const authReducer = (initialState: AuthState, action: AuthActionTypes): AuthState => {
  switch (action.type) {
    case AuthTypes.AUTH_REQUEST:
      return {
        ...initialState, authRequest: true, authError: null
      }
    case AuthTypes.AUTH_ERROR:
      return {
        ...initialState, authRequest: false, authError: action.authError, authToken: null
      }
    case AuthTypes.AUTH_SUCCESS:
      return {
        ...initialState, authInit: true, authRequest: false, authError: null, authToken: action.authToken
      }
    case AuthTypes.AUTH_LOGOUT:
      return {
        ...initialState, authInit: true, authError: null, authToken: null
      }
    default:
      return initialState
  }
}
